import React, { useEffect, useState } from "react";

function CreditosComprados() {
  const [creditos, setCreditos] = useState([]);
  const [form, setForm] = useState({ id_user: "", credito: "" });
  const [loading, setLoading] = useState(false);
  const [mostrarForm, setMostrarForm] = useState(false);

  function carregar() {
    fetch("https://videooferta.com/api/listar_creditos.php", {
      method: "POST"
    })
      .then(res => res.json())
      .then(data => setCreditos(data))
      .catch(err => console.error(err));
  }

  useEffect(() => {
    carregar();
  }, []);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  }

  function adicionarCreditos(e) {
    e.preventDefault();
    setLoading(true);

    fetch("https://videooferta.com/api/adicionar_creditos.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(form)
    })
      .then(res => res.json())
      .then(data => {
        setLoading(false);
        if (data.status === "ok") {
          alert(data.msg);
          setForm({ id_user: "", credito: "" });
          carregar();
        } else {
          alert(data.msg);
        }
      })
      .catch(() => {
        setLoading(false);
        alert("Erro ao comunicar com o servidor");
      });
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5>Créditos Comprados</h5>

       <button
  type="button"
  className="btn btn-success btn-sm"
  onClick={() => setMostrarForm(v => !v)}
  aria-expanded={mostrarForm}
>
  <i className="fa fa-plus"></i> {mostrarForm ? "Fechar" : "Adicionar Créditos"}
</button>
      </div>

      <table className="table table-bordered table-striped small align-middle">
        <thead>
          <tr>
            <th>ID</th>
            <th>ID Usuário</th>
            <th>Usuário</th>
            <th>E-mail</th>
            <th>Créditos</th>
            <th>Plano</th>
            <th>Valor</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          {creditos.map(c => (
            <tr key={c.id}>
              <td>{c.id}</td>
              <td>{c.id_user}</td>
              <td>{c.nome_user}</td>
              <td>{c.email}</td>
              <td>{c.credito}</td>
              <td>{c.plano}</td>
              <td>R$ {Number(c.valor).toFixed(2)}</td>
              <td>{new Date(c.data_compra).toLocaleString("pt-BR")}</td>
            </tr>
          ))}

          {creditos.length === 0 && (
            <tr>
              <td colSpan="8" className="text-center">
                Nenhum crédito encontrado
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* FORM ADICIONAR CRÉDITOS */}
      {mostrarForm && (
      <div className="mt-3" id="formCreditos">
  <form onSubmit={adicionarCreditos} className="card card-body">
    <div className="mb-2">
      <label>ID do Usuário</label>
      <input
        className="form-control"
        name="id_user"
        value={form.id_user}
        onChange={handleChange}
        required
      />
    </div>

    <div className="mb-2">
      <label>Créditos</label>
      <input
        type="number"
        className="form-control"
        name="credito"
        min="1"
        value={form.credito}
        onChange={handleChange}
        required
      />
    </div>

    <button className="btn btn-success">
      Adicionar Créditos
    </button>
  </form>
</div>
      )}

    </div>
  );
}

export default CreditosComprados;
